'use client';

import React, { useState, useEffect } from 'react';
import Link from "next/link";
import { useParams } from "next/navigation";
import clsx from "clsx";

const SidebarInner = ({headerApiData, onClick, brandData, propertyData}) => {
    const { propertySlug, citySlug } = useParams();
    const [open, setOpen] = useState(false);
    const [isDesktop, setIsDesktop] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const checkScreen = () => {
            const desktop = window.innerWidth >= 768;
            setIsDesktop(desktop);
        };

        checkScreen();
        window.addEventListener("resize", checkScreen);
        return () => window.removeEventListener("resize", checkScreen);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 100);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const toggleSidebar = () => setOpen(prev => !prev);
    const closeSidebar = () => {
        setOpen(false);
       // onClick();
    };

    return (
        <>
            {/* ☰ Toggle Button */}
            <button
                className="clarks-sidebar-toggler"
                onClick={toggleSidebar}
                aria-label="Toggle Sidebar"
            >
                <span />
                <span />
                <span />
            </button>

            {/* 🔲 Overlay */}
            {open && (
                <div className="clarks-sidebar-overlay" onClick={closeSidebar}></div>
            )}

            {/* 📑 Sidebar */}
            <div
                className={clsx("clarks-sidebar", {
                    open,
                    "clarks-sidebar-scrolled": isScrolled,
                })}
            >
                {/* ✖️ Close Button */}
                <div className="clarks-sidebar-header">
                    <button
                        className="clarks-sidebar-close"
                        onClick={closeSidebar}
                        aria-label="Close"
                    >
                        ✕
                    </button>
                </div>

                {/* 📄 Menu */}
                <ul className="clarks-sidebar-menu">
                    <li><Link href={`/${propertySlug}/${citySlug}`} onClick={closeSidebar}>Overview</Link></li>
                    {headerApiData?.[0]?.room &&   <li><Link href={`/${brandData.find(
        (brand) => brand.hotelBrandId === propertyData.hotelBrandId
      )?.brandSlug || ""}/${propertySlug}/${citySlug}/rooms`} onClick={closeSidebar}>Rooms</Link></li>}
                     {headerApiData?.[0]?.event &&  <li><Link href={`/${brandData.find(
        (brand) => brand.hotelBrandId === propertyData.hotelBrandId
      )?.brandSlug || ""}/${propertySlug}/${citySlug}/events`} onClick={closeSidebar}>Events</Link></li>}
                     {headerApiData?.[0]?.dine &&  <li><Link href={`/${brandData.find(
        (brand) => brand.hotelBrandId === propertyData.hotelBrandId
      )?.brandSlug || ""}/${propertySlug}/${citySlug}/dining`} onClick={closeSidebar}>Dining</Link></li>}
                     {headerApiData?.[0]?.offer &&  <li><Link href={`/${brandData.find(
        (brand) => brand.hotelBrandId === propertyData.hotelBrandId
      )?.brandSlug || ""}/${propertySlug}/${citySlug}/offers`} onClick={closeSidebar}>Offers</Link></li>}
                    <li><Link href={`/${brandData.find(
        (brand) => brand.hotelBrandId === propertyData.hotelBrandId
      )?.brandSlug || ""}/${propertySlug}/${citySlug}/gallery`} onClick={closeSidebar}>Gallery</Link></li>
                    <li><Link href={`/${brandData.find(
        (brand) => brand.hotelBrandId === propertyData.hotelBrandId
      )?.brandSlug || ""}/${propertySlug}/${citySlug}/contact`} onClick={closeSidebar}>Contact</Link></li>
                    {/* <li><Link href="#" onClick={closeSidebar}>Login/Join</Link></li> */}
                    <li>
                        <a href="#" className="box-btn know-more p-2" onClick={()=>{closeSidebar(); onClick();}}>Book Now</a>
                    </li>
                </ul>
            </div>
        </>
    );
};

export default SidebarInner;
